import Vue from 'vue'

import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import VueSocialSharing from 'vue-social-sharing'
import 'bootstrap/dist/css/bootstrap.min.css'; // Importa el CSS de Bootstrap
import 'bootstrap'; // Importa JavaScript de Bootstrap

import routes from './router'
import guards from './router/guards'
import messages from './i18n'
import './assets/main.scss'

import 'bootstrap'

Vue.config.productionTip = false

Vue.use(VueSocialSharing)
Vue.use(VueRouter)
Vue.use(VueI18n)

const render = h => h('div', { attrs: { id: 'elfocoapp' } }, [
  h('RouterView')
])

const i18n = new VueI18n({ locale: 'es', messages })
const mode = ''
const router =  guards({router: new VueRouter({
  mode: mode,
  routes  
}), i18n })


new Vue({ router, render, i18n }).$mount('#elfocoapp')